import Colors from '@/constants/Colors';

/** WCAG AA contrast for white label text on Clever SSO button */
export const loginSignInButtonCleverBackground = '#2948c9';

/** WCAG AA contrast for white label text on ClassLink SSO button */
export const loginSignInButtonClasslinkBackground = Colors.darkBlue;

/** WCAG AA contrast for label text on Google SSO button */
export const loginSignInButtonGoogleText = Colors.textBlack;
